var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareDouble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 210,
    viewBox: "0 0 173 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.3648 208.263L0.797845 124.696C-0.265948 123.632 -0.265948 121.859 0.797845 120.677L84.3648 37.11C85.4286 36.0462 87.2015 36.0462 88.3835 37.11L171.95 120.677C173.014 121.741 173.014 123.514 171.95 124.696L88.3835 208.263C87.2015 209.326 85.4286 209.326 84.3648 208.263Z",
    fill: "#2A3B6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0725 106.02L34.0104 54.958C33.3012 54.2488 33.3012 53.185 34.0104 52.4758L85.0725 1.5319C85.7817 0.822701 86.8455 0.822701 87.5547 1.5319L138.617 52.594C139.326 53.3032 139.326 54.367 138.617 55.0762L87.5547 106.138C86.8455 106.729 85.7817 106.729 85.0725 106.02Z",
    stroke: "#445597",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareDouble);
export default __webpack_public_path__ + "static/media/square-double.914fb2415b34f4d7412ebdbdfa2a4912.svg";
export { ForwardRef as ReactComponent };